<template>
	<div class="table">
		<Table
			:columns="normalizedColumns"
			:data-source="normalizedItems"
			:pagination="normalizedPagination"
			:loading="loading"
			:row-selection="rowSelection"
			@change="onChange"
			bordered
		>
			<template v-for="slot of slots" :slot="slot" slot-scope="text, record">
				<slot :name="slot" v-bind="record" />
			</template>
		</Table>
	</div>
</template>
<script>
import { Table } from "ant-design-vue"

export default {
	name: "UikitTable",

	components: {
		Table
	},

	props: {
		columns: { type: Array, required: true },
		items: { type: Array, required: true },
		loading: { type: Boolean, default: false },
		rowSelection: { type: Object },
		pagination: { type: [Object, Boolean], default: null }
	},

	computed: {
		/**
		 * Слоты
		 */
		slots() {
			return this.columns.filter(column => column.slot).map(column => column.slot)
		},

		/**
		 * Нормализованные колонки
		 */
		normalizedColumns() {
			return this.columns.map((column, index) => {
				column = { ...column }
				column.key = column.key || column.field || column.slot || index

				if (column.field) {
					column.dataIndex = column.field
				}
				if (column.slot) {
					column.scopedSlots = { customRender: column.slot }
				}

				return column
			})
		},

		/**
		 * Нормализованные записи
		 */
		normalizedItems() {
			return this.items.map((item, index) => {
				const key = item.key || item.id || index

				return { ...item, key }
			})
		},

		normalizedPagination() {
			if (this.pagination === false) {
				return false
			}

			if (this.pagination) {
				return this.pagination
			}

			return { defaultPageSize: 20 }
		}
	},

	methods: {
		onChange(pagination, filters, sorter, extra) {
			this.$emit("change", { pagination, filters, sorter, extra })
		}
	}
}
</script>

<style lang="scss" scoped>
.table {
	background: white;

	/deep/ tr:nth-child(2n) td {
		background-color: #fafafa;
	}
	/deep/ thead th {
		background-color: #fafafa;
	}
}
</style>
